// import { ACCOUNT_LOGOUT } from '../../store/actions';
import api from '../../views/services/api';
import { useHistory } from 'react-router-dom';

// import { ACCOUNT_LOGOUT } from '../store/actions';

const Redirect = () => {
    const history = useHistory();
    history.push('/login');
};

// export const logout = (dispatch) => {
//     // remove tokens
//     localStorage.removeItem('access_token');
//     localStorage.removeItem('refresh_token');

//     // limpa axios (se existir)
//     if (window.axios?.defaults?.headers?.common) {
//         delete window.axios.defaults.headers.common.Authorization;
//     }

//     // redux
//     dispatch({
//         type: ACCOUNT_LOGOUT
//     });
// };

export const fetchMe = () => api.get('users/me/');
